export default "__VITE_ASSET__BycPj$b5__"